import { render } from "./MaintenanceMode.vue?vue&type=template&id=38ba2415&scoped=true&ts=true"
import script from "./MaintenanceMode.vue?vue&type=script&lang=ts"
export * from "./MaintenanceMode.vue?vue&type=script&lang=ts"

import "./MaintenanceMode.vue?vue&type=style&index=0&id=38ba2415&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ba2415"]])

export default __exports__